import styled from 'styled-components'
import { device } from '../../theme'

export const PageHeaderWrap = styled.div`
    position: relative;
    background-repeat: no-repeat;
    background-position: center center;
    border-bottom-width: 0px;
    padding-top: 136px;
    padding-bottom: 131px;
    background-size: cover;
    text-align: center;
    @media ${device.large}{
        padding-top: 80px;
        padding-bottom: 80px;
    }
    nav.breadcrumb{
        display: inline-block;
        padding: 0;
        padding-left: 6px;
        margin-bottom: 0;
        border-radius: 0;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 2px;
        line-height: 1.58;
        text-transform: uppercase;
        background-color: transparent;
        color: ${props => props.textColor ?? props.theme.colors.themeColor};
    }
    .breadcrumb__list{
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 0;
        margin: 0;
    }
    .breadcrumb__list__item{
        margin: 0 0.25em;
    }
    .breadcrumb__link{
        position: relative;
        color: ${props => props.textColor ?? props.theme.colors.themeColor};
        text-decoration: none;
        &:after{
            content: '';
            width: 0;
            height: 1px;
            bottom: 0;
            position: absolute;
            left: auto;
            right: 0;
            z-index: -1;
            transition: width 0.6s cubic-bezier(0.25, 0.8, 0.25, 1) 0s;
            background: currentColor;
        }
        &:hover{
            &:after{
                width: 100%;
                left: 0;
                right: auto;
                z-index: 0;
            }
        }
    }
    .breadcrumb__link__active{
        color: ${props => props.textColor ?? props.theme.colors.themeColor};
        text-decoration: none;
        &:after{
            display: none;
        }
    }
    .breadcrumb__separator{
        color: ${props => props.textColor ?? props.theme.colors.themeColor};
    }
    .breadcrumb__title{
        font-size: 56px;
        font-weight: 700;
        color: ${props => props.textColor ?? props.theme.colors.themeColor};
        display: block;
        margin-bottom: 20px;
        @media ${device.large}{
            font-size: 46px;
            line-height: 1.4;
        }
        @media ${device.medium}{
            font-size: 40px;
        }
        @media ${device.small}{
            font-size: 34px;
        }
    }
`;